(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-partner/assets/javascripts/components/logout.js') >= 0) return;  svs.modules.push('/modules/grassroots-partner/assets/javascripts/components/logout.js');
'use strict';

const Button = svs.ui.ReactButton;
const Logout = () => {
  const navigate = () => svs.utils.url.navigate('/grasrotenpartner/login');
  const handleLogout = () => svs.core.jupiter.delete('/partner/1/sponsorship/sessions', navigate, navigate);
  return React.createElement("div", {
    className: "padding-bottom-2"
  }, React.createElement(Button, {
    onClick: handleLogout
  }, "Logga ut"));
};
svs.grassroots_partner.Logout = Logout;

 })(window);